import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPage } from "@/pages/legal/PrivacyPage";
import { localizedHead } from "@/lib/seo";

export const Route = createFileRoute("/privacy")({
  head: () => {
    const lh = localizedHead({ path: "/privacy", locale: "da" });
    return {
      meta: [
        { title: "Privatlivspolitik — Farveladeland" },
        {
          name: "description",
          content: "Sådan håndterer Farveladeland dine personoplysninger.",
        },
        { property: "og:title", content: "Privatlivspolitik — Farveladeland" },
        {
          property: "og:description",
          content: "Sådan håndterer Farveladeland dine personoplysninger.",
        },
        ...lh.meta,
      ],
      links: lh.links,
    };
  },
  component: PrivacyPage,
});
